module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5f12e8bceba4f21180c7e49a028281ef.png";